export const PRO_ONE_MONTH_PROMO_CODE = 'pro1month'
export const FIRST_MONTH_FREE = 'firstmonthfree'
